import { generatePath } from "react-router";

export enum ROLES {
  SUPER_ADMIN = "Super Admin",
  PATIENT = "Patient",
  ADMIN = "Admin",
  MEDICAL_COORDINATOR = "Medical Coordinator",
  MEDICAL_STAFF = "Medical Staff",
}

export const NamesOfParentRoutes = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  MANAGEMENT: "/management",
  PATIENT: "/patient",
  PUBLIC: "/public",
};

export const NameOfChildRoutes = {
  AUTH: {
    LOGIN: "/login",
    SIGN_UP: "/signup",
    VERIFY_USER: "/verify-user",
    SET_PASSWORD: "/set-password",
  },
  PUBLIC: {
    FORMS: "/forms/:code",
  },
  MANAGEMENT: {
    USERS: {
      ROOT: "/users",
      LIST: "/",
    },
    HOSPITALS: {
      ROOT: "/hospitals",
      SETTINGS: "/settings",
      LIST: "/",
    },
    SENSORS: {
      ROOT: "/sensors",
      LIST: "/",
    },
    SENSOR_DATA_FILES: {
      ROOT: "/files",
      DETAILS: "/:file_id/details",
      LIST: "/",
    },
    SENSOR_DATA_RESTORING_REQUESTS: {
      ROOT: "/requests",
      LIST: "/",
    },
    SENSOR_DATA_SESSIONS: {
      ROOT: "/sessions",
      DETAILS: "/:session_id/details",
      LIST: "/",
    },
    STATIONS: {
      ROOT: "/stations",
      LIST: "/",
    },
    PATIENTS: {
      ROOT: "/patients",
      LIST: "/",
      DETAILS: "/:patient_id/details",
    },
    DASHBOARD: {
      ROOT: "/dashboard",
      LIST: "/",
    },
    REPORTS: {
      ROOT: "/reports",
      EXPORT: "/",
    },
  },
  DASHBOARD: {
    HOSPITAL: "/hospital",
  },
  PATIENT: {
    FORMS: {
      ROOT: "/forms",
      LIST: "/",
    },
  },
};

export const getPatientsPageURL = () =>
  `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.PATIENTS.ROOT}${NameOfChildRoutes.MANAGEMENT.PATIENTS.LIST}`;

export const getSensorDataFilesPageURL = () =>
  `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_FILES.ROOT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_FILES.LIST}`;

export const getSensorDataFilePageURL = (id: number) =>
  generatePath(
    `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_FILES.ROOT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_FILES.DETAILS}`,
    {
      file_id: String(id),
    },
  );

export const getSensorDataSessionsPageURL = () =>
  `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_SESSIONS.ROOT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_SESSIONS.LIST}`;

export const getSensorDataSessionPageURL = (id: number) =>
  generatePath(
    `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_SESSIONS.ROOT}${NameOfChildRoutes.MANAGEMENT.SENSOR_DATA_SESSIONS.DETAILS}`,
    {
      session_id: String(id),
    },
  );
